import * as Configurations from './environments';

export const IS_PROD = process.env.REACT_APP_ENV === 'prod';
export const IS_QA = process.env.REACT_APP_ENV === 'qa';

export const isLocalhost = () => (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// fetch secretes here if necessary
export default Configurations[process.env.REACT_APP_ENV as keyof typeof Configurations];
